import {
    GET_ALL_PROJECTS_REQUESTED,
    GET_ALL_PROJECTS_SUCCEEDED,
    GET_ALL_PROJECTS_FAILED,
    GET_ALL_PLACES_REQUESTED,
    GET_ALL_PLACES_SUCCEEDED,
    GET_ALL_PLACES_FAILED,
    GET_ALL_ZONES_REQUESTED,
    GET_ALL_ZONES_SUCCEEDED,
    GET_ALL_ZONES_FAILED,
    GET_PLACES_REQUESTED,
    GET_PLACES_SUCCEEDED,
    GET_PLACES_FAILED,
    CREATE_PROJECT_REQUESTED,
    CREATE_PROJECT_SUCCEEDED,
    CREATE_PROJECT_FAILED,
    ASSIGN_PLACES_REQUESTED,
    ASSIGN_PLACES_SUCCEEDED,
    ASSIGN_PLACES_FAILED,
    ASSIGNEE_REQUESTED,
    ASSIGNEE_SUCCEEDED,
    ASSIGNEE_FAILED,
    RESEARCHERS_REQUESTED,
    RESEARCHERS_SUCCEEDED,
    RESEARCHERS_FAILED,
    SET_PROJECT,
    SET_ZONE,
    SET_STATUS,
    SET_PLACES,
    SET_ACTIVE_PLACE_ID,
    RESET_PLACE_DETAIL,
    EDIT_PLACE_REQUESTED,
    EDIT_PLACE_SUCCEEDED,
    EDIT_PLACE_FAILED,
    DELETE_PLACE_REQUESTED,
    DELETE_PLACE_SUCCEEDED,
    DELETE_PLACE_FAILED,
    UNASSIGN_RESEARCHER_FAILED,
    UNASSIGN_RESEARCHER_REQUESTED,
    UNASSIGN_RESEARCHER_SUCCEEDED,
    SET_FILTER_BY,
    SET_SORT_BY,
    SET_SELECTED_PLACES_ACTION,
    SET_SELECTED_RESEARCHERS_ACTION,
} from './constants';

export function setProject(project) {
    return {
        type: SET_PROJECT,
        project,
    };
}

export function setZone(zone) {
    return {
        type: SET_ZONE,
        zone,
    };
}

export function setStatus(status) {
    return {
        type: SET_STATUS,
        status,
    };
}

export function setPlaces(places) {
    return {
        type: SET_PLACES,
        places,
    };
}

export function getPlacesRequested(loadingMore = false) {
    return {
        type: GET_PLACES_REQUESTED,
        loadingMore,
    };
}

export function getPlacesSucceeded({ places, skip, hasMorePlaces }) {
    return {
        type: GET_PLACES_SUCCEEDED,
        places,
        skip,
        hasMorePlaces,
    };
}

export function getPlacesFailed(error) {
    return {
        type: GET_PLACES_FAILED,
        error,
    };
}

export function createProjectRequested(name, file) {
    return {
        type: CREATE_PROJECT_REQUESTED,
        name,
        file,
    };
}

export function createProjectSucceeded(createdProject) {
    console.log('Redux actions: createProjectSucceeded', createdProject);
    return {
        type: CREATE_PROJECT_SUCCEEDED,
        createdProject,
    };
}

export function createProjectFailed(error) {
    return {
        type: CREATE_PROJECT_FAILED,
        error,
    };
}

export function editPlaceRequested(action) {
    return {
        type: EDIT_PLACE_REQUESTED,
        name: action.name,
        lat: action.lat,
        long: action.long,
        placeId: action.placeId,
    };
}

export function editPlaceSucceeded(place) {
    return {
        type: EDIT_PLACE_SUCCEEDED,
        place,
    };
}

export function editPlaceFailed(error) {
    return {
        type: EDIT_PLACE_FAILED,
        error,
    };
}

export function deletePlaceRequested(placeId) {
    return {
        type: DELETE_PLACE_REQUESTED,
        placeId,
    };
}

export function deletePlaceSucceeded(placeId) {
    return {
        type: DELETE_PLACE_SUCCEEDED,
        placeId,
    };
}

export function deletePlaceFailed(error) {
    return {
        type: DELETE_PLACE_FAILED,
        error,
    };
}

export function unassignUserFromPlaceRequested(
    projectId,
    placeId,
    researcherId,
) {
    return {
        type: UNASSIGN_RESEARCHER_REQUESTED,
        projectId,
        placeId,
        researcherId,
    };
}

export function unassignUserFromPlaceSucceeded(
    projectId,
    placeId,
    researcherId,
) {
    return {
        type: UNASSIGN_RESEARCHER_SUCCEEDED,
        projectId,
        placeId,
        researcherId,
    };
}

export function unassignUserFromPlaceFailed(error) {
    return {
        type: UNASSIGN_RESEARCHER_FAILED,
        error,
    };
}

export function assignUsersToPlacesRequested(projectId, placeIds, researchers) {
    return {
        type: ASSIGN_PLACES_REQUESTED,
        projectId,
        placeIds,
        researchers,
    };
}

export function assignUsersToPlacesSucceeded({ placeIds, researchers }) {
    return {
        type: ASSIGN_PLACES_SUCCEEDED,
        placeIds,
        researchers,
    };
}

export function assignUsersToPlacesFailed(error) {
    return {
        type: ASSIGN_PLACES_FAILED,
        error,
    };
}

export function assigneeRequested(placeId) {
    return {
        type: ASSIGNEE_REQUESTED,
        placeId,
    };
}

export function assigneeSucceeded(placeDetail) {
    return {
        type: ASSIGNEE_SUCCEEDED,
        placeDetail,
    };
}

export function assigneeFailed(error) {
    return {
        type: ASSIGNEE_FAILED,
        error,
    };
}
export function setActivePlaceId(id) {
    return {
        type: SET_ACTIVE_PLACE_ID,
        id,
    };
}

export function setFilterBy(filterBy) {
    return {
        type: SET_FILTER_BY,
        filterBy,
    };
}

export function setSortBy(sortBy) {
    return {
        type: SET_SORT_BY,
        sortBy,
    };
}

export function researchersRequested() {
    return {
        type: RESEARCHERS_REQUESTED,
    };
}

export function researchersSucceeded(researchers) {
    return {
        type: RESEARCHERS_SUCCEEDED,
        researchers,
    };
}

export function researchersFailed(error) {
    return {
        type: RESEARCHERS_FAILED,
        error,
    };
}

export function resetPlaceDetail() {
    return {
        type: RESET_PLACE_DETAIL,
    };
}

export function getAllProjectsRequested() {
    return {
        type: GET_ALL_PROJECTS_REQUESTED,
    };
}

export function getAllProjectsSucceeded(projects) {
    return {
        type: GET_ALL_PROJECTS_SUCCEEDED,
        projects,
    };
}

export function getAllProjectsFailed() {
    return {
        type: GET_ALL_PROJECTS_FAILED,
    };
}

export function getAllPlacesRequested() {
    return {
        type: GET_ALL_PLACES_REQUESTED,
    };
}

export function getAllPlacesSucceeded(places) {
    return {
        type: GET_ALL_PLACES_SUCCEEDED,
        places,
    };
}

export function getAllPlacesFailed() {
    return {
        type: GET_ALL_PLACES_FAILED,
    };
}

export function getAllZonesRequested() {
    return {
        type: GET_ALL_ZONES_REQUESTED,
    };
}

export function getAllZonesSucceeded(zones) {
    return {
        type: GET_ALL_ZONES_SUCCEEDED,
        zones,
    };
}

export function getAllZonesFailed() {
    return {
        type: GET_ALL_ZONES_FAILED,
    };
}

export function setSelectedPlacesAction(selectedPlaces) {
    return {
        type: SET_SELECTED_PLACES_ACTION,
        selectedPlaces,
    };
}

export function setSelectedResearchersAction(selectedResearchers) {
    return {
        type: SET_SELECTED_RESEARCHERS_ACTION,
        selectedResearchers,
    };
}
